import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvCdssTrnService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '0',
      _env: 'cdss-trn',
      _apiUrl: 'https://trn3-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://trn3-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer:
        'https://cdsstrnadb2c.b2clogin.com/d273fe80-ceec-4907-b667-72b0532f8849/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl:
        'https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: 'b7144eb9-a80f-4590-a3ca-163a601752db',
      _scope:
        'openid profile https://cdsstrnadb2c.onmicrosoft.com/api/cdss.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://trn3-login.p-cis.com/',
      _signInURL:
        "https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp",
      _signInURLSSO:
        "https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO",
      _adb2cTenantUrl:
        'https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _oktaClientId: '0oag4pjnccJymdJVS1d7',
      _oktaIssuer: 'https://child-welfare-digital-services.oktapreview.com/oauth2/ausg4pw2f3vLM5mwV1d7',
      _oktaRedirectUri: 'https://trn3-login.p-cis.com/auth/okta/callback',
      _authEndpoint:
        'https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://cdsstrnadb2c.b2clogin.com/cdsstrnadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'

    };
  }
}
